/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';

import globalReducer from 'containers/App/reducer';

/*
 * routeReducer
 *
 * The reducer keeps track of the route location.
 * This is kept for compatibility but no longer synced via middleware.
 *
 */

// Initial routing state
const routeInitialState = fromJS({
  location: null,
});

/**
 * Route reducer (no longer updated by middleware, kept for compatibility)
 */
export function routeReducer(state = routeInitialState) {
  return state;
}

/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer(injectedReducers) {
  return combineReducers({
    route: routeReducer,
    global: globalReducer,
    ...injectedReducers,
  });
}
